export const StateChanges = {
  // ** from front end *
  RESET_EXPERIMENT: 'RESET_EXPERIMENT',
  ADD_CLASS: 'ADD_CLASS',
  REMOVE_CLASS: 'REMOVE_CLASS',
  UPDATE_CLASS: 'UPDATE_CLASS',
  SET_TEST_TEXT: 'SET_TEST_TEXT',
  SET_CHUNKING: 'SET_CHUNKING',
  SET_EXPERIMENT_NAME: 'SET_EXPERIMENT_NAME',

  SET_TEXT_NAME: 'SET_TEXT_NAME',

  SET_FEATURE_SETS: 'SET_FEATURE_SETS',
  SET_REMOVED_FEATURES: 'SET_REMOVED_FEATURES',
  ADD_FEATURE_SET: 'ADD_FEATURE_SET',
  REMOVE_FEATURE_SET: 'REMOVE_FEATURE_SET',
  ENABLE_FEATURE_SET: 'ENABLE_FEATURE_SET',
  DISABLE_FEATURE_SET: 'DISABLE_FEATURE_SET',
  DISABLE_FEATURE: 'DISABLE_FEATURE',
  ENABLE_FEATURE: 'ENABLE_FEATURE',
  BATCH_FEATURE_CHANGES: 'BATCH_FEATURE_CHANGES',

  UPDATE_FEATURES_RUNNING: 'UPDATE_FEATURES_RUNNING',

  EXTRACT_FEATURES_RUNNING: 'EXTRACT_FEATURES_RUNNING',
  CROSSVALIDATION_RUNNING: 'CROSSVALIDATION_RUNNING',
  CLASSIFY_RUNNING: 'CLASSIFY_RUNNING',

  EXTRACT_FEATURES_TIMED_OUT: 'EXTRACT_FEATURES_TIMED_OUT',
  EXTRACT_FEATURES_FAILED: 'EXTRACT_FEATURES_FAILED',
  CROSSVALIDATION_TIMED_OUT: 'CROSSVALIDATION_TIMED_OUT',
  CROSSVALIDATION_FAILED: 'CROSSVALIDATION_FAILED',
  CLASSIFY_TIMED_OUT: 'CLASSIFY_TIMED_OUT',
  CLASSIFY_FAILED: 'CLASSIFY_FAILED',

  // ** from server *
  SET_FEATURE_RESULTS: 'SET_FEATURE_RESULTS',
  SET_CROSSVALIDATION_RESULTS: 'SET_CROSSVALIDATION_RESULTS',
  SET_TEST_TEXT_RESULTS: 'SET_TEST_TEXT_RESULTS',
  // ** from firebase *
  FIREBASE_RECEIVED_UPDATE: 'FIREBASE_RECEIVED_UPDATE',
  SET_SAVE_MESSAGE: 'SET_SAVE_MESSAGE',
  RESET_SAVE_MESSAGE: 'RESET_SAVE_MESSAGE',
  UPDATE_SAVED_TEXTS: 'UPDATE_SAVED_TEXTS',
  UPDATE_SAVED_EXPERIMENTS: 'UPDATE_SAVED_EXPERIMENTS',
  LOGIN_REQUESTED: 'LOGIN_REQUESTED',
  LOGIN_CONTINUING: 'LOGIN_CONTINUING',
  LOGIN_COMPLETE: 'LOGIN_COMPLETE',
  LOGIN_CANCELLED: 'LOGIN_CANCELLED',
  LOGGED_OUT: 'LOGGED_OUT',

  SAVE_FAVORITE: 'SAVE_FAVORITE',
  DELETE_FAVORITE: 'DELETE_FAVORITE',
  SAVE_EXPERIMENT: 'SAVE_EXPERIMENT',
  UNSAVE_EXPERIMENT: 'UNSAVE_EXPERIMENT'
}

export const Actions = {
  RUN_EXTRACT_FEATURES: 'RUN_EXTRACT_FEATURES',
  RUN_CV: 'RUN_CV',
  RUN_CLASSIFICATION: 'RUN_CLASSIFICATION',

  PROCESS_LOGIN: 'PROCESS_LOGIN',
  LOGOUT: 'LOGOUT',

  LOAD_EXPERIMENT: 'LOAD_EXPERIMENT',

  // ** from firebase *
  SET_SAVE_RESULT: 'SET_SAVE_RESULT'
}



// WEBPACK FOOTER //
// ./src/store/stateChanges.js